import { getPatientHome } from './endpoints';
import { fetchPatientHome } from './actions/fetchPatientHome';

export * from './types';
export { getPatientHome, fetchPatientHome };

const PatientHomeService = { getPatientHome, fetchPatientHome };
export default PatientHomeService;
